import api from 'api';
import ApiService from 'api/ApiService';
import {getName} from 'redux/common/saga/getName';
import {call, put} from 'redux-saga/effects';
import i18n from 'i18n';
import {AdminRole, IAdminRole} from 'types/diplomat/settings/adminroles/AdminRole';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {DialogTypes, DialogResult} from 'common/names';
import {asyncSagaConstructor, unhandedSagaError} from 'redux/common';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';
import {pushSuccessToast} from 'features/notifications/redux/actions';
import {settingsTypes} from '..';
import {castToSend} from 'common/yup/castToSend';
import {Action} from 'redux/helpers';

export function* createAmdinRoleSaga(act: Action<IAdminRole>) {
   const data = {...act.payload, id: undefined};
   try {
      const name = (yield call(
         getName,
         act.payload ? i18n.t('Clone Role') : i18n.t('Create new Role'),
         i18n.t('Role Name')
      )) as string;

      if (!name) return;

      data.name = name;
      yield call(postData, data);
   } catch (e) {
      if (JSON.stringify(e).indexOf('Duplicate') >= 0) {
         yield call(openOverwriteConfirm, data!);
      }
   }
}

function* openOverwriteConfirm(data: Partial<IAdminRole>) {
   try {
      const dialogResult: ICloseSubDialogAction<null> = yield call(openDialogWithResult, {
         id: DialogTypes.ConfirmationDialog.id,
         title: i18n.t('A Diplomat Admin Role with that name already exists.'),
         content: i18n.t('Do you want to overwrite that Admin Role with a new one?'),
      });

      const shouldOverwrite = dialogResult.payload?.result === DialogResult.OK;

      if (shouldOverwrite) {
         yield call(postData, {...data, overwrite: true});
      }
   } catch (e) {
      yield call(unhandedSagaError, e as Error);
      console.error(e);
   }
}

function* postData(data: Partial<IAdminRole>) {
   yield call(
      asyncSagaConstructor(api.adminrolesCreate, settingsTypes.CREATE_ADMIN_ROLE, {
         getMethod: ApiService.postSecureJson,
         data: castToSend(AdminRole, data),
      })
   );
   // yield call(ApiService.postSecureJson, api.adminroles, JSON.stringify(data));
   yield put(pushSuccessToast(i18n.t('Role "{{name}}" successfully created', {name: data.name})));

   // TODO refetch
   // yield put(settingsActions.fetchAdminRoles);

   yield call(
      asyncSagaConstructor(api.adminroles, settingsTypes.FETCH_ADMIN_ROLES, {
         getMethod: ApiService.getSecureJson,
      })
   );
}
